
import ContactForm from '../components/ContactForm'
// import Sponsors from '../components/Sponsors'
// import IntSlides from '../components/IntSlides'
// import BreadCrumbs from '../components/BreadCrumbs'
export default {
  auth: false,
  components: {
    // BreadCrumbs,
    // Sponsors,
    // IntSlides,
    ContactForm
  },
  data () {
    return {
      lang: 'es',
      cont: {
        en: {
          tit1: `Somos ${process.env.STORE_NAME}`,
          par1: 'Beauty & fashion center is a company dedicated to the sale and distribution of a variety of wholesale and retail items, including the areas of jewelry, makeup, piñateria, perfumery, personal items, toys, among others. Our attention is completely personalized to make your purchase a comfortable experience. Our advisors are at your disposal for any questions or concerns that may arise. Our mission in the market is to be a leading company and stand out in the sale of excellent quality items for the whole family. We also offer guaranteed and monitored security 24 hours a day for your greatest comfort.',
          tit2: 'Our Products',
          par2: 'We bring innovative and effective products focused on the quality/price ratio, offering excellence, comfort and meeting the needs of our customers so that they can find everything in one place and be more pleasant.',
          tit3: 'Stock',
          par3: 'We have all the stock and a great variety to guarantee that you get all materials needed to make your artificial grass, Ivy wall or mulch project happen fast, with the best quality and efficiency. ',
          tit4: '¡We are breaking boundaries!',
          par4: 'We offer delivery and cover projects all over South-Florida. If your project requires a special delivery you can contact us. We deliver nationwide, The Caribbean, and Latin America. Our goal is to make Beauty&Fashion center a leading company of artificial grass, and to be one of the main distributors all over the state of Florida, creating along the way innovative projects that satisfy all our client`s needs.'
        },
        es: {
          tit1: `Somos ${process.env.STORE_NAME}`,
          par1: 'Beauty & fashion center es una compañía dedicada a la venta y distribución de una variedad de artículos al mayor y al detal entre los que destacan las áreas de bisutería, maquillaje, piñateria, perfumería, artículos personales, jugueteria, entre otros. Nuestra atención es totalmente personalizada para hacer de su compra una experiencia confortable. Nuestros asesores están a su disposición para cualquier duda o inquietud que se le pueda presentar. Nuestra misión en el mercado es ser una empresa líder y destacarnos en la venta de artículos de excelente calidad para toda la familia. También les ofrecemos seguridad garantizada y monitoreada las 24 horas del día para su mayor comodidad.',
          tit2: 'Nuestros Productos',
          par2: 'Traemos productos innovadores y eficaces enfocados en la relación calidad/precio ofreciendoles excelencia, comodidad y que cubran las necesidades de nuestros clientes para que puedan encontrar todo en un solo lugar y pueda ser de mayor agrado.',
          tit3: 'Stock',
          par3: 'Nuestro stock se destaca por la variedad de productos de maquillaje, skincare especializado para la mujer venezolana así como también productos de aseo personal, área de bisutería entre los que tienen gran demanda son artículos como anillos, collares igualmente en el área de fiesta y diversión el cuál llama considerablemente la atención ya que tenemos termos, globos, salvavidas y más.',
          tit4: '¡Queremos llegar más allá!',
          par4: 'Ya que tenemos alta demanda en nuestros artículos al mayor ponemos a su disposición nuestro servicio de delivery a toda la gran Caracas, contamos con envíos a nivel nacional e internacional, así como también descuentos en compras al gran mayor. Si deseas comunicarte con nosotros puedes hacerlo a través de los siguientes medios: WhatsApp: 0416-2137014, Instagram: @beautyfashioncenter.c.a, Correo: beautyfashioncenterca@gmail.com. \n\nQueremos convertirnos en tu tienda de preferencia y ser su cómplice tanto en sus ocasiones especiales como en su día a día.'
        }
      },
      topSlides: [
        {
          title: '',
          img: 'slider3.jpg'
        },
        {
          title: '',
          img: 'slider.jpg'
        }
      ],
      rightSlides: [
        {
          img: 'about1.jpg'
        },
        {
          img: 'about2.jpg'
        }
      ],
      leftSlides: [
        {
          img: 'about3.jpg'
        },
        {
          img: 'about5.jpg'
        }
      ]
    }
  },
  head: {
    title: 'Acerca de Nosotros',
    meta: [
      { hid: 'og:title', name: 'og:title', content: 'Acerca de Nosotros' },
      { hid: 'description', name: 'description', content: 'Acerca de Nosotros' }
    ]
  }
}
